var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{on:{"click":_vm.sort}},[_c('div',{class:{
        'app-list-th': true,
        'sort': !!_vm.sortBy,
        'theme--dark': this.getTheme
        },on:{"mouseover":_vm.onHover,"mouseleave":function($event){return _vm.onHover(false)}}},[(_vm.getValue)?[_vm._v(" "+_vm._s(_vm.getValue)+" ")]:[_vm._t("default")],(_vm.sortBy && !_vm.direction)?_c('v-icon',{style:(`opacity: ${_vm.hover && !_vm.direction ? '0.5' : '0'}`),attrs:{"x-small":""}},[_vm._v(" north ")]):_vm._e(),(_vm.sortBy && _vm.direction)?_c('v-icon',{attrs:{"x-small":""}},[_vm._v(" "+_vm._s(_vm.direction === 'asc' ? 'north' : 'south')+" ")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }